// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_s7-5";
export var filledCircle = "_s7-4";
export var historyEntry = "_s7-3";
export var messageSideLeft = "_s7-1";
export var messageSideRight = "_s7-2";
export var orderTrackingCarouselWrapper = "_s7-6";
export var orderTrackingInfoContainer = "_s7-0";